/* Slow, seamless artist strip. Duplicate visuals are excluded from accessibility. */
if (!customElements.get('rewind-artist-carousel')) {
  customElements.define('rewind-artist-carousel', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.rw-credits__carousel');
      this.toggle = this.querySelector('.rw-credits__motion');
      if (!this.scroller || !this.toggle) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.track = this.scroller.querySelector('.rw-credits__track');
      this.originals = Array.from(this.track.children);
      this.clones = this.originals.map(artist => {
        const clone = artist.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('data-shopify-editor-block');
        this.track.append(clone);
        return clone;
      });
      this.position = this.scroller.scrollLeft;
      this.visible = false;
      this.paused = false;
      this.resumeAt = 0;
      this.update = () => {
        this.clones.forEach(clone => { clone.hidden = this.motion.matches; });
        this.limit = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        this.cycle = this.clones[0]?.offsetLeft - this.originals[0]?.offsetLeft;
        this.toggle.hidden = !this.limit || this.motion.matches;
        this.position = this.scroller.scrollLeft;
      };
      this.motion.addEventListener('change', this.update, options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
        this.toggle.textContent = this.paused ? 'Resume scrolling' : 'Pause scrolling';
      }, options);
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && this.scroller.clientWidth >= 750) this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.scroller.addEventListener('pointerdown', () => { this.keyboardMode = false; this.dragging = true; }, options);
      window.addEventListener('pointerup', () => { if (this.dragging) { this.dragging = false; this.resumeAt = performance.now() + 4000; } }, options);
      window.addEventListener('pointercancel', () => { this.dragging = false; this.resumeAt = performance.now() + 4000; }, options);
      this.scroller.addEventListener('wheel', () => { this.resumeAt = performance.now() + 4000; }, { ...options, passive: true });
      this.addEventListener('keydown', () => { this.keyboardMode = true; }, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.scroller);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.intersection.observe(this);
      this.update();
      const frame = now => {
        const elapsed = Math.min((now - (this.previous || now)) / 1000, 0.05);
        this.previous = now;
        const stopped = this.motion.matches || !this.visible || document.hidden || this.paused || this.hovered || this.dragging || (this.keyboardMode && this.contains(document.activeElement)) || now < this.resumeAt || !this.limit || !this.cycle;
        if (stopped) this.position = this.scroller.scrollLeft;
        else {
          this.position = (this.position + elapsed * 18) % this.cycle;
          this.scroller.scrollLeft = this.position;
        }
        this.frame = requestAnimationFrame(frame);
      };
      this.frame = requestAnimationFrame(frame);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      this.clones?.forEach(clone => clone.remove());
    }
  });
}
